module.exports = __webpack_public_path__ + "static/media/check-circle-1.d8399e0b.svg";